<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2a"><a id="page_xxiii"></a>ABBREVIATIONS</h2>
<p class="normal">ADC: African Divine Church</p>
<p class="normala">AFBFM: American Friends Board of Foreign Missions</p>
<p class="normala">AIC: African Inland Church</p>
<p class="normala">AICN: African Israel Church Nineveh</p>
<p class="normala">C.A.: Christ’s Ambassadors</p>
<p class="normala">CMS: Church Missionary Society</p>
<p class="normala">FAIM: Friends Africa Industrial Mission</p>
<p class="normala">FAM: Friends African Mission</p>
<p class="normala">GB: Golden Bells (hymnal)</p>
<p class="normala">KNA: Kenya National Archives</p>
<p class="normala">NZI: Nyimbo za Injili (hymnal)</p>
<p class="normala">OAU: Organization of African Unity</p>
<p class="normala">PAG: Pentecostal Assemblies of God</p>
<p class="normala">PAOC: Pentecostal Assemblies of Canada</p>
<p class="normala">RS: Redemption Songs (hymnal)</p>
<p class="normala">SATB: soprano, alto, tenor, bass</p>
<p class="normala">SSS: Sunday School Songs (hymnal)</p>
<p class="normala">TH: Tabernacle Hymns (hymnal)</p>
<p class="normala">TTN: Tsinyimbu tsya Nyasaye (hymnal)</p>
<div class="pagebreak">
<p class="bodytext"> </p>
<h1 class="h1a"><a id="page_xxv"></a>MUSIC IN KENYAN CHRISTIANITY</h1>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abbreviations.vue?4f406ffa